<template>
  <v-container class="pa-0" fluid id="planner_joblistcontainer">

    <ListToolbar v-model="sortedjobs" :inputlist="jobs" :sortablefields="sortablefields"
      :filterablefields="filterablefields">

      <template v-slot:toolbar-content-center>
        <v-card flat color="transparent" class="d-flex">
          <v-container class="pa-0">
            <v-row no-gutters :class="vertical ? 'pt-0' : ''">
              <!--
              <v-col>
                <QAutoComplete v-model="FilterStatus" :label="$t('servicesystem.common_objects.job.status')"
                  :list="statuses" :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]" :externaledit="true"
                  class="mx-3" :singleline="!vertical">
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      {{ item.Name }}
                    </v-list-item-content>
                    <v-list-item-icon class="mx-0 my-auto">
                      <CardBadge :color="'primary'" :count="item.Count" :index="0">
                      </CardBadge>
                      <CardBadge :color="'#4397E8'" :count="subsatusCount(item.Id)" :index="1">
                      </CardBadge>
                    </v-list-item-icon>
                  </template>
</QAutoComplete>
</v-col>
-->
              <v-col>
                <QAutoComplete v-model="FilterSubStatus" :label="$t('servicesystem.common_objects.job.substatus')"
                  :list="substatuses" :textkey="'Name'" :valuekey="'Id'" clearable :externaledit="true" singleline
                  :disabled="!substatuses || !substatuses.length"
                  :placeholder="substatuses && substatuses.length ? $t('servicesystem.common_objects.commonterms.any') : undefined">
                  <template v-slot:prepend-outer>
                    <v-icon>mdi-folder</v-icon>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon v-if="item.Id == 0" class="mr-2" color="warning" size="14">mdi-cancel</v-icon>
                    <v-list-item-content :class="item.Id == 0 ? 'warning--text' : ''">
                      {{ item.Name }}
                    </v-list-item-content>
                    <v-list-item-icon class="mx-0 my-auto">
                      <CardBadge :color="'primary'" :count="item.Count" :index="0">
                      </CardBadge>
                    </v-list-item-icon>
                  </template>
                </QAutoComplete>
              </v-col>

            </v-row>
          </v-container>
        </v-card>
      </template>

      <template v-slot:toolbar-content-right>
        <RefreshBtn :method="'plannerstore/GetUnplannedJobs'"
          :externalLoading="$store.getters['plannerstore/UnplannedJobListLoading']"
          :tip="$t('servicesystem.common_objects.job.refresh_list')" :size="'small'" class="mx-2" :autoTimer="60000">
        </RefreshBtn>
      </template>
    </ListToolbar>


    <QScroll :list="sortedjobs" :height="vertical ? 'calc(100vh - 191px)' : '222px'"
      :minheight="vertical ? 'calc(100vh - 200px)' : '222px'" :horizontal="!vertical"
      :loading="$store.getters['plannerstore/UnplannedJobListLoading'] && (!sortedjobs || !sortedjobs.length)"
      :skeletonloading="true">

      <template v-slot:list-item="{ item, index }">
        <div class="br-draggable ignoreodd" :data-index="index" :data-jobid="item.Id" :data-subject="item.DisplayName"
          :data-estimatedtime="item.EstimatedTime">
          <v-card v-if="JobListItemMode == 'card'" class="ma-2 pa-3">
            <b>
              <router-link :to="{ name: 'ViewJob', params: { filter: 'my', jobId: item.Id } }" class="minimalLink"
                style="user-drag: none;">{{ item.DisplayName }}</router-link>
              <br>
            </b>
            <v-chip x-small class="my-1" style="border-radius: 4px;">{{ item.JobTypeName }}</v-chip>
            <p v-if="item.DeliveryAddress" class="my-1">
              <v-icon size="17">mdi-map-marker</v-icon>
              {{ [item.DeliveryAddress.Street, item.DeliveryAddress.City, item.DeliveryAddress.Zip,
              item.DeliveryAddress.Country].join(" ") }}
            </p>
            <div v-for=" mj  in  item.Jobs " :key="mj.Id"
              style="font-size: 12px; display: -webkit-box; -webkit-line-clamp: 10; -webkit-box-orient: vertical; overflow: hidden;">
              <router-link :to="{ name: 'ViewMachine', params: { machineId: mj.MachineId } }" class="minimalLink"
                style="user-drag: none;">
                {{ mj.DisplayName }}
              </router-link>
              : {{ mj.CustomerComment }}
            </div>
          </v-card>
          <JobListItem2 v-else :jobItem="item" 
            :selected="item.selected" 
            :hover="item.hover" 
            :showStatus="true" 
            :showAddress="true" 
            :draggable="false" 
            :nav-disabled="true"
            @mouseover="hover(item)"
            @click="click"
            >
          </JobListItem2>
        </div>
      </template>

      <template v-slot:skeleton-loader="{ index }">
        <v-card v-if="!vertical" class="mx-2 my-3 mb-5" max-width="200" min-width="200" height="190" elevation="0"
          :style="'opacity: ' + (10 - index) / 10 + ';'">
          <v-skeleton-loader height="190" type="list-item, divider, list-item,  list-item,  list-item">
          </v-skeleton-loader>
        </v-card>
        <v-card v-else class="py-3" elevation="0" :style="'opacity: ' + (10 - index) / 10 + ';'">
          <v-skeleton-loader type="list-item-avatar, list-item, divider">
          </v-skeleton-loader>
        </v-card>
      </template>

      <template v-slot:empty-list>
        <v-card height="222px" color="transparent" flat class="d-flex flex-column align- center justify-center">
          <v-icon v-text="'mdi-briefcase-remove'" class="mb-5" size="70" />
          <h3 class="useThemeTextColor mx-7 text-center"
            v-text="$t('servicesystem.common_objects.fallbackterms.no_unplanned_jobs')" />
        </v-card>
      </template>

    </QScroll>
    <v-divider />
    <div v-html="myStyle" />
  </v-container>
</template>


<script>
import CardBadge from "@/components/Buttons/CardBadge.vue";
import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";
import JobListItem2 from "@/components/ListItems/JobListItem/JobListItem-nodevexpress.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import ListToolbar from "@/views/admin/machines/ListToolbar.vue";

export default {
  name: "JobCardList",
  components: {
    RefreshBtn,
    ListToolbar,
    QScroll,
    CardBadge,
    JobListItem2
  },
  props: ["vertical"],

  data() {
    return {
      currentEstimatedTime: 1,
      sortedjobs: [],
      draggingGroupName: "appointmentsGroup",

      sortablefields: [
        { key: "OrderId", type: "int", displayString: "servicesystem.common_objects.order.order_id" },
        { key: "StatusId", type: "int", displayString: "servicesystem.common_objects.job.status" },
        { key: "JobPriorityDueAfterHours", type: "int", displayString: "servicesystem.common_objects.job.priority" },
        { key: "JobTypeName", type: "string", displayString: "servicesystem.common_objects.job.type" },
        //{ key: "CreatedDate", type: "datetime", displayString: "servicesystem.common_objects.job.created" },
      ],
      filterablefields: [],
    };
  },

  mounted() {
    this.getjobs();
  },

  methods: {
    click(item) {
      this.$emit("select",item)
    },
    hover(item) {
      this.jobs.forEach(e => {
        if (e.hover == true && e.Id != item.Id) {
          e.hover = false;
        } 
      })
      item.hover = true
    },
    async getjobs() {
      await this.$store.dispatch("plannerstore/GetUnplannedJobs");
    },

    onListDragStart(e) {
      e.cancel = true;
    },

    subsatusCount(parentStatusId) {
      var list = Object.assign([], this.$store.getters["LookUpStore/JobSubStatusListByParent"](parentStatusId));
      var count = 0;
      list.forEach((x) => {
        count += x.Count;
      });
      return count;
    },

    onItemDragStart(e) {
      const pageX = e.event.pageX;
      const pageY = e.event.pageY;
      e.element.style.position = 'fixed';
      e.element.style.left = `${pageX / 2}px`;
      e.element.style.top = `${pageY / 2}px`;
      this.currentEstimatedTime = e.fromData.EstimatedTime;
      e.itemData = e.fromData;
    },

    onItemDragEnd(e) {
      e.element.style.position = '';
      if (e.toData) {
        e.cancel = true;
      }
    },
  },

  computed: {
    jobs: {
      get() {
        return this.$store.getters["plannerstore/UnplannedJobList"];
      },
      set(update) {
        this.$store.dispatch("plannerstore/SetUnplannedJobsList", update);
      },
    },

    JobListItemMode() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerJobListItemMode");
    },

    FilterStatus: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListStatusFilter");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListStatusFilter", value: update });
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListSubStatusFilter", value: null });
        this.getjobs();
      },
    },

    FilterSubStatus: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListSubStatusFilter");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListSubStatusFilter", value: update });
        this.getjobs();
      },
    },

    statuses() {
      var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
      var filteredstatuses = statuses.filter((y) => y.Id < 70);

      return filteredstatuses;
    },

    substatuses() {
      var list = Object.assign([], this.$store.getters["LookUpStore/JobSubStatusListByParent"](this.FilterStatus));
      if (list && list.length) {
        var parentStatusCount = (this.statuses.find(x => x.Id == this.FilterStatus)).Count
        list.push({ Id: 0, Name: this.$t('servicesystem.common_objects.commonterms.none'), Count: parentStatusCount })
        return list
      }
      else {
        return [];
      }
    },

    myStyle() {
      return `
      	<style>
        .dx-scheduler-date-table-droppable-cell::after {
          width: ` + (this.currentEstimatedTime * 4 * 30) + `px;
        }
        </style>
        `;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.minitoolbar {
  position: sticky;
  width: 100%;
  z-index: 4;
  //box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}

.joblist {
  display: flex;
  max-width: 100%;
  overflow-x: overlay !important;
  z-index: 5;
}

.joblist.vertical {
  flex-direction: column;
  align-items: center;
  overflow-y: overlay !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .joblist {
    overflow-x: auto !important;
  }

  .joblist.vertical {
    overflow-y: auto !important;
  }
}
</style>

<style lang="scss">
.minitoolbar.lowered,
.minitoolbar.lowered .v-toolbar__content {
  height: 41px !important;
}

.minimalLink {
  text-decoration: none;
}

.minimalLink:hover {
  text-decoration: underline;
}
</style>
